<template>
	<v-container grid-list-md class="pa-0 container--box">
		<v-layout row wrap>
			<v-flex xs12 md3>
				<v-card flat color="transparent">
					<v-card-title primary-title>
						{{ $t("Filter") }}
					</v-card-title>
					<v-card-text>
						<v-expansion-panels accordion hover multiple>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("title.price_level") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-chip-group
										v-model="filter.price_levels"
										column
										multiple
									>
										<v-chip
											filter
											outlined
											v-for="(
												price_level, index
											) in price_levels"
											:key="'price_level.' + index"
											small
										>
											{{ price_level }}
										</v-chip>
									</v-chip-group>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("title.cuisines") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-chip-group
										v-model="filter.cuisines"
										column
										multiple
									>
										<v-chip
											filter
											outlined
											v-for="(cuisine, index) in cuisines"
											:key="'cuisine.' + index"
											small
										>
											{{ cuisine.name }}
										</v-chip>
									</v-chip-group>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 md9>
				<ShopTenantGrid :tenants="tenants"></ShopTenantGrid>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import ShopTenantGrid from "@Shop/components/ShopTenantGrid.vue";
export default {
	components: {
		ShopTenantGrid,
	},

	props: ["tenants", "cuisines", "price_levels"],

	data() {
		return {
			filter: {
				cuisines: [],
			},
		};
	},
};
</script>